export default __webpack_public_path__ + "static/media/blog02.9b2bcf64.png";